<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Unidades
        </p>
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Minhas Unidades Ativas
        </span>
        <div
          class="row col-md-12 col-xs-12 justify-end text-brand-5 text-weight-bold q-mb-lg container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            v-model="busca"
            debounce="300"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaUnidadesAtivas"
        :loading="loading"
        dense
        color="primary"
        class="tabela-tamanho-fixo"
        :rows-per-page-options="[0]"
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        flat
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-9">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong
                    >{{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong
                    >{{ props.row.name }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Região: </strong
                    >{{ props.row.code }}</span
                  >
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Depósito: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.deposito
                    }}</span>
                    <input
                      v-else
                      v-model="dados.deposito"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descarga: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.descarga
                    }}</span>
                    <input
                      v-else
                      v-model="dados.descarga"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Centro de Custo: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.codigoCentroCusto
                    }}</span>
                    <input
                      v-else
                      v-model="dados.codigoCentroCusto"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Centro: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.centro
                    }}</span>
                    <input
                      v-else
                      v-model="dados.centro"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Requisitante: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.requisitante
                    }}</span>
                    <input
                      v-else
                      v-model="dados.requisitante"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Requisitante: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.requisitante
                    }}</span>
                    <input
                      v-else
                      v-model="dados.requisitante"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Recebedor: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.recebedor
                    }}</span>
                    <input
                      v-else
                      v-model="dados.recebedor"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Data Necessidade: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.diasNecessidade
                    }}</span>
                    <input
                      v-else
                      v-model="dados.diasNecessidade"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Ativo: </strong>
                    <span v-if="!props.selected">{{
                      props.row.parametros.ativo == 1 ? "Ativo" : "Inativo"
                    }}</span>
                    <select
                      v-model="estadoGrid"
                      class="input-grid"
                      v-else
                      name="select"
                    >
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </span>
                </div>
                <div class="row col-2">
                  <q-btn
                    v-if="!props.selected"
                    icon="edit"
                    round
                    color="primary"
                    @click="
                      (props.selected = !props.selected),
                        recebeDados(props.row, props.row.parametros.ativo)
                    "
                  />
                  <q-btn
                    v-else
                    icon="done"
                    round
                    color="positive"
                    @click="atualizarUnidade(props.row.parametros.ativo)"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.name }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.code }}</span>
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.deposito }}</span
              >
              <q-input
                style="width: 90px"
                dense
                outlined
                v-else
                v-model="dados.deposito"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.descarga }}</span
              >
              <q-input
                style="width: 210px"
                dense
                outlined
                v-else
                v-model="dados.descarga"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.codigoCentroCusto }}</span
              >
              <q-input
                style="width: 110px"
                dense
                outlined
                v-else
                v-model="dados.codigoCentroCusto"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.centro }}</span
              >
              <q-input
                style="width: 110px"
                dense
                outlined
                v-else
                v-model="dados.centro"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.requisitante }}</span
              >
              <q-input
                style="width: 110px"
                dense
                outlined
                v-else
                v-model="dados.requisitante"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.recebedor }}</span
              >
              <q-input
                style="width: 110px"
                dense
                outlined
                v-else
                v-model="dados.recebedor"
              />
            </q-td>
            <q-td>
              <span v-if="!props.selected">
                {{ props.row.parametros.diasNecessidade }}</span
              >
              <q-input
                style="width: 80px"
                dense
                outlined
                v-else
                v-model="dados.diasNecessidade"
              />
            </q-td>
            <q-td>
              <q-select
                v-if="props.selected"
                v-model="props.row.parametros.ativo"
                :options="options.ativo"
                dense
                outlined
                map-options
              />
              <span v-else>{{
                props.row.parametros.ativo == 1 ? "Ativo" : "Inativo"
              }}</span>
            </q-td>
            <q-td>
              <q-btn
                v-if="!props.selected"
                icon="edit"
                round
                color="primary"
                @click="
                  (props.selected = !props.selected),
                    recebeDados(props.row, props.row.parametros.ativo)
                "
              />
              <q-btn
                v-else
                icon="done"
                round
                color="positive"
                @click="atualizarUnidade(props.row.parametros.ativo)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "regiao",
    label: "Região",
    align: "left",
  },
  {
    name: "deposito",
    label: "Depósito",
    align: "left",
  },
  {
    name: "descarga",
    label: "Descarga",
    align: "left",
  },
  {
    name: "centrodecusto",
    label: "Centro de Custo",
    align: "left",
  },
  {
    name: "centro",
    label: "Centro",
    align: "left",
  },
  {
    name: "requisitante",
    label: "Requisitante",
    align: "left",
  },
  {
    name: "recebedor",
    label: "Recebedor",
    align: "left",
  },
  {
    name: "datanecessidade",
    label: "Data Necessidade",
    align: "left",
  },
  {
    name: "ativo",
    label: "Ativo",
    align: "left",
  },
  {
    name: "salvar",
    label: "Salvar",
    align: "left",
  },
];
export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const listaUnidadesAtivas = ref([]);
    const busca = ref("");
    const estadoGrid = ref("");
    let loading = ref(false);
    const estado = ref({ label: "Ativo", value: 1 });
    const options = {
      ativo: [
        { label: "Ativo", value: 1 },
        { label: "Inativo", value: 0 },
      ],
    };
    const selected = ref([]);
    const dados = ref({
      ativo: "",
      centro: "",
      codigoCentroCusto: "",
      deposito: "",
      descarga: "",
      diasNecessidade: "",
      planta: "",
      providerId: "",
      recebedor: "",
      requisitante: "",
      vendor_id: "",
    });

    const listarUnidadesAtivas = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch("integracao/listarUnidades", {
          per_page: 100,
          search: busca.value,
        });
        listaUnidadesAtivas.value = response.data.results.data;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const atualizarUnidade = async (estado) => {
      let estadoValue = dados.value.ativo;
      if (estado) {
        estadoValue = estado.value;
      }
      if (screen.width < 600) {
        estadoValue = estadoGrid.value;
      }
      try {
        await store.dispatch("integracao/atualizarUnidade", {
          ativo: estadoValue,
          centro: dados.value.centro,
          codigoCentroCusto: dados.value.codigoCentroCusto,
          deposito: dados.value.deposito,
          descarga: dados.value.descarga,
          diasNecessidade: dados.value.diasNecessidade,
          planta: dados.value.planta,
          providerId: dados.value.providerId,
          recebedor: dados.value.recebedor,
          requisitante: dados.value.requisitante,
          vendor_id: dados.value.vendor_id,
        });
        selected.value = [];
        estadoGrid.value = "";
        quasar.notify({
          message: "Dados da unidade atualizados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarUnidadesAtivas();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const recebeDados = async (row, estado) => {
      let estadoValue = row.parametros.ativo;
      if (estado) {
        estadoValue = estado.value;
      }
      dados.value = {
        ativo: estadoValue,
        centro: row.parametros.centro,
        codigoCentroCusto: row.parametros.codigoCentroCusto,
        deposito: row.parametros.deposito,
        descarga: row.parametros.descarga,
        diasNecessidade: row.parametros.diasNecessidade,
        planta: row.parametros.planta,
        providerId: row.parametros.providerId,
        recebedor: row.parametros.recebedor,
        requisitante: row.parametros.requisitante,
        vendor_id: row.id,
      };
    };

    onMounted(listarUnidadesAtivas);

    return {
      columns,
      options,
      listarUnidadesAtivas,
      listaUnidadesAtivas,
      estado,
      selected,
      atualizarUnidade,
      dados,
      recebeDados,
      estadoGrid,
      loading,
      busca,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-multiplo-grid {
    width: 100px;
  }
  .input-grid {
    width: 70px;
    outline: none;
  }
}
</style>
